const useGoogleSSO = () => {
  const loadScript = (src) =>
    new Promise((resolve, reject) => {
      if(document.querySelector(`script[src="${src}"]`)) resolve()
      const script = document.createElement('script')
      script.src = src
      script.async = true
      script.defer = true
      script.onload = () => resolve()
      script.onerror = (err) => reject(err)
      document.body.appendChild(script)
    })

  const generateRandomNonce = () => {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    const length = 16
    let nonce = ''
    for(let i = 0; i < length; i += 1) {
      const randomIndex = Math.floor(Math.random() * characters.length)
      nonce += characters.charAt(randomIndex)
    }
    return nonce
  }

  return { loadScript, generateRandomNonce }
}

export default useGoogleSSO
